// Unified nutrient-score bands (SP-0). Mirrors NourishmentEngine ScoreBadgeMapper, Consumers.UI
// scoreBadgeFromScore, and Producers.Web.UI scoreBand. Inputs are a 0-1 or a 0-100 score.
export enum ScoreBand {
  Best = 'best',
  Good = 'good',
  Okay = 'okay',
  Poor = 'poor',
  Avoid = 'avoid'
}

export const scoreBand = (score: number): ScoreBand => {
  const s = score <= 1 ? score * 100 : score;
  if (s >= 80) return ScoreBand.Best;
  if (s >= 60) return ScoreBand.Good;
  if (s >= 40) return ScoreBand.Okay;
  if (s >= 20) return ScoreBand.Poor;
  return ScoreBand.Avoid;
};

// Class modifier token; a null score (no data) yields 'none'.
export const scoreBandModifier = (score: number | null): string => (score === null ? 'none' : scoreBand(score));
